import { Colors, Typography, AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { transparentize } from 'polished';
import { IoIosCreate } from 'react-icons/io';
import styled from 'styled-components';
import previewImg from 'assets/pics/ip-preview-premium.jpg';

// utils
import media from 'utils/mediaQueries';

export const StyledTypography = styled(Typography)`
  color: ${Colors.blue};
  font-weight: ${({ theme }) => theme.font.weights.bold};
  margin-bottom: 1rem;
`;
export const Container = styled.div`
  margin: 3rem 0;
`;
export const TemplateContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin: 2rem 4.5rem;
  grid-gap: 2rem;

  ${media.customMaxWidth(1300)} {
    grid-template-columns: repeat(4, 1fr);
  }

  ${media.customMaxWidth(1000)} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const TemplateOverlay = styled.div`
  background: white;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  border-radius: 15px;
  transition: opacity 0.4s ease-in-out;
`;

export const StyledTemplate = styled.div<AnalyticsProps>`
  position: relative;
  height: 150px;
  background: url(${previewImg});
  background-position: center;
  background-size: cover;
  border-radius: 15px;
  box-shadow: 0 0 17px 2px ${transparentize(0.13, Colors.darkGray)};
  justify-content: center;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
  font-weight: ${({ theme }) => theme.font.weights.bold};

  > p {
    color: ${Colors.white};
  }

  :hover {
    ${TemplateOverlay} {
      opacity: 0.7;
    }

    > p {
      transition: color 0.4s ease-in-out;
      color: ${Colors.blue};
    }
  }
`;

export const HoveredItem = styled(Typography)`
  color: ${Colors.skyBlue};
  opacity: 1;
  :hover {
    cursor: pointer;
    text-decoration-line: underline;
  }
`;

export const HoveredIcon = styled(IoIosCreate)<AnalyticsProps>`
  color: ${Colors.blue};
  width: 2.3rem;
  height: 2.3rem;
  cursor: pointer;

  :hover {
    transform: scale(1.4);
    transition: transform 0.2s ease-in-out;
  }
`;

export const TemplateTitle = styled(Typography)`
  z-index: 10;
`;
export const TemplateImage = styled.img`
  width: 100%;
  border-radius: 10px;
  margin-bottom: 1rem;
  min-height: 20%;
`;
export const HoveredContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
`;

export const TypeContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${Colors.gray};
`;
export const TypeIcon = styled.span`
  color: ${Colors.blue};
  padding-right: 0.4rem;
  vertical-align: center;

  > svg {
    height: 1.3rem;
    width: 1.3rem;
  }
`;

export const DropdownList = styled.div`
  background: ${Colors.white};
  border-radius: 10px;
  min-height: 0;
  padding: 0.4rem 0;
  box-shadow: 0 0 8px 1px ${transparentize(0.87, Colors.black)};
  position: relative;
`;

export const TemplateOptions = styled(DropdownList)`
  position: absolute;
  left: 10.3rem;
  z-index: 1;
  width: 100%;
  display: inline-table;
  div {
    &:last-child {
      text-align: center;
    }
  }
`;

export const DropdownContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  position: absolute;
  top: 3.5rem;
`;
export const DropdownItem = styled.div<AnalyticsProps>`
  padding: 0.4rem 0 0.4rem 0.6rem;
  transition: all 0.2s;
  width: 10rem;
  :hover {
    cursor: pointer;
    background-color: ${transparentize(0.85, Colors.fontGray)};
    border-radius: 1px;
  }
`;
export const ViewAll = styled(DropdownItem)`
  padding: 0.2rem;
  border-top: 1px solid ${transparentize(0.85, Colors.fontDarkGray)};
  font-size: ${({ theme }) => theme.font.sizes.extraSmall};
  color: ${Colors.skyBlue};
`;
export const FlexContainer = styled.div`
  display: flex;
`;
export const ButtonContainer = styled(FlexContainer)`
  flex-direction: column;
  position: relative;
`;
export const IconHolder = styled.span`
  padding-right: 0.3rem;
  vertical-align: middle;
`;
export const ExpandAll = styled.div`
  text-align: center;
`;
